import React from 'react';
import { keyFigures } from '../data/content';
export function StatsStrip() {
  return <section aria-label="Die Sammlung in Zahlen" className="bg-navy-900 px-5 py-10" data-id="element-212" data-mp="ghf2bxirm4yo">
      <div className="mx-auto grid max-w-4xl grid-cols-2 gap-6 rounded-2xl border border-white/10 bg-navy-700 px-6 py-7 sm:grid-cols-4" data-id="element-213" data-mp="2ifg0wiq625o">
        {keyFigures.map(figure => <div key={figure.label} className="text-center" data-id="element-214" data-mp="v6l2potca185">
            <p className="font-display text-3xl font-black text-gold sm:text-4xl" data-id="element-215" data-mp="v738bc1w5rsq">
              {figure.value}
            </p>
            <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-white/60 sm:text-xs" data-id="element-216" data-mp="107h5fz1yfhbz">
              {figure.label}
            </p>
          </div>)}
      </div>
    </section>;
}